// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"f49a1e78","184":"9aef3322","448":"119736da","632":"3ee9792f","724":"f49a1e78","896":"f49a1e78","916":"ca748fa4"}[chunkId] + ".chunk.css";
};